import moment from 'moment'

/**
 * 格式化日期
 * @param {日期} params 
 * @returns 
 */
export function dateFormat(params) {
  return moment(params).format('YYYY-MM-DD')
}
/**
 * 按照指定格式格式化日期
 * @param {日期} date 
 * @param {格式化格式} fmt 
 * @returns 
 */
export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
};

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

/**
 * 获取近7天日期
 */
export function sevenDays(){
  let days = [];
  var date = new Date();
  //144是前6天的小时数
  for(let i=0; i<144; i+=24){
    let dateItem=new Date(date.getTime() - i * 60 * 60 * 1000);	//使用当天时间戳减去以前的时间毫秒（小时*分*秒*毫秒）
			let y = dateItem.getFullYear();	//获取年份
			let m = dateItem.getMonth() + 1;	//获取月份js月份从0开始，需要+1
			let d= dateItem.getDate();	//获取日期
			m = addDate(m);	//给为单数的月份补零
			d = addDate(d);	//给为单数的日期补零
			let valueItem= y + '-' + m + '-' + d;	//组合
			days.push(valueItem);	//添加至数组
  }
  return days;
}

//给日期加0
function addDate(time) {
  if (time.toString().length == 1) {
    time = '0' + time.toString();
  }
  return time;
}



// WEBPACK FOOTER //
// ./src/utils/date.js